import { render } from "./TheSidebarBoard.vue?vue&type=template&id=3b012304&scoped=true"
import script from "./TheSidebarBoard.vue?vue&type=script&lang=js"
export * from "./TheSidebarBoard.vue?vue&type=script&lang=js"

import "./TheSidebarBoard.vue?vue&type=style&index=0&id=3b012304&scoped=true&lang=css"
import "./TheSidebarBoard.vue?vue&type=style&index=1&id=3b012304&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b012304"

export default script